"use strict"

import AppBasicLayout from "../templates/layouts/basic/basicLayout.controller";
import AppDocsLayout from "../templates/layouts/docs/docsLayout.controller";

import { Loader } from "./loader";

const routes = [
	{path: "/", 							config: {page: "start",						view: ""}},
	{path: "/docs#:hash", 					config: {page: "start",						view: ""}},
	{path: "/docs", 						config: {page: "start",						view: ""}},
	{path: "/docs/introduction#:hash",		config: {page: "start",						view: ""}},
	{path: "/docs/introduction",			config: {page: "start",						view: ""}},
	{path: "/docs/installation",			config: {page: "installation",				view: ""}},
	{path: "/docs/primitive-tokens#:hash",	config: {page: "core-primitive-tokens",		view: ""}},
	{path: "/docs/primitive-tokens",		config: {page: "core-primitive-tokens",		view: ""}},
	{path: "/docs/app-tokens#:hash",		config: {page: "core-app-tokens",			view: ""}},
	{path: "/docs/app-tokens",				config: {page: "core-app-tokens",			view: ""}},
	{path: "/docs/component-tokens#:hash",	config: {page: "core-component-tokens",		view: ""}},
	{path: "/docs/component-tokens",		config: {page: "core-component-tokens",		view: ""}},
	{path: "/docs/design-assets#:hash",		config: {page: "core-design-assets",		view: ""}},
	{path: "/docs/design-assets",			config: {page: "core-design-assets",		view: ""}},
	{path: "/docs/utilities#:hash",			config: {page: "core-utils",				view: ""}},
	{path: "/docs/utilities",				config: {page: "core-utils",				view: ""}},

	//{path: "/browser-support",			config: {page: "support",					view: ""}},
	//{path: "/content/link", 			config: {page: "content-link",				view: ""}},
	//{path: "/content/table",			config: {page: "content-table",				view: ""}},
	//{path: "/content/list",				config: {page: "content-list",				view: ""}},
	//{path: "/content/image",			config: {page: "content-image",				view: ""}},
	//{path: "/content/video",			config: {page: "content-video",				view: ""}},
	
	
	//{path: "/components/section",		config: {page: "component-section",			view: ""}},
	//{path: "/components/button",		config: {page: "component-button",			view: ""}},
	//{path: "/components/accordion",		config: {page: "component-accordion",		view: ""}},
	//{path: "/components/tabs",			config: {page: "component-tabs",			view: ""}},
	//{path: "/components/forms",			config: {page: "component-forms",			view: ""}},
	//{path: "/components/stack",			config: {page: "component-stack",			view: ""}},
	//{path: "/components/dropdown",		config: {page: "component-dropdown",		view: ""}},
	//{path: "/components/alert",			config: {page: "component-alert",			view: ""}},
	//{path: "/components/modal",			config: {page: "component-modal",			view: ""}},
	{path: "/404", 						config: {page: "404",						view: ""}}
];

export default routes;